import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DiscountLevel } from "../../models/discount/discount-level";
import { DiscountLevelsService } from "../../services/discount-levels.service";
import { DropDownFilterSettings } from "@progress/kendo-angular-dropdowns";

@Component({
    selector: 'set-discount-level',
    templateUrl: './set-discount-level.component.html',
    styleUrls: ['./set-discount-level.component.scss']
})
export class SetDiscountLevelComponent implements OnInit {

    @Input() showConfirmButton: boolean = true;

    @Output() changeValue: EventEmitter<number> = new EventEmitter<number>();
    @Output() commitChanges: EventEmitter<any> = new EventEmitter<any>();

    discountLevels: DiscountLevel[] = [];

    discountLevelId: number;
    rate: number;

    constructor(
        private discountLevelsService: DiscountLevelsService
    ) { }

    ngOnInit(): void {
        this.discountLevelsService.getAll().subscribe(data => {
            this.discountLevels = data;
        });
    }

    changeDiscountLevel(discountLevelId: number) {
        let discountLevel = this.discountLevels.find(x => x.discountLevelId == discountLevelId);
        this.changeValue.emit(discountLevel.rate);
        this.rate = discountLevel.rate;
    }

    saveChanges() {
        let discountLevel = this.discountLevels.find(x => x.discountLevelId == this.discountLevelId);
        this.commitChanges.emit(discountLevel.rate);
    }
    
    public dropDownFilterSettings: DropDownFilterSettings = { caseSensitive: false, operator: 'contains' };   
}